import React, { useEffect, useRef, useState } from 'react'
import Attachment from '../../../../Components/common/Attachment'
import Tasks from './Tasks'
import Activity from './Activity'
import { ReactComponent as Activity_icon } from "../../../../assets/images/shift_report/activity.svg";
import { ReactComponent as Task_icon } from "../../../../assets/images/shift_report/task.svg";
import { ReactComponent as Attachment_icon } from "../../../../assets/images/shift_report/attachment.svg";
import { ReactComponent as Remarks_icon } from "../../../../assets/images/icon_svg/remarks.svg";
import { ReactComponent as Onduty } from "../../../../assets/images/resetting.svg";
import { toast } from 'react-toastify';
import { CallApi, CommonModal } from '../../../../Components/common/CommonFunctions'; 
import { Button, Form } from 'react-bootstrap'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';  
import { faClock, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Remarks } from '../../../../Components/common/Remarks';


const ShiftDetails = () => {

    const shiftId = localStorage.getItem('SDetails');
    const isMounted = useRef(false);
    const [selectedTab, setSelectedTab] = useState('ACT')
    const [details, setDetails] = useState({})
    const [sendData, setSendData] = useState({})
    const [showModal, setShowModal] = useState(false)
    const [remarks, setRemarks] = useState(false)

    const loadDetails = () => {
        CallApi({
            endPoint: `shift-report/get-record-details/${shiftId}`,
            method: 'GET',
            onSuccess: (res) => {
                const data = res.data.response_data;
                setDetails(data);
                setSendData({ attType: 'shift_report', id: data?.id });
            },
            onError: (msg) => toast.error(msg)
        });
    }
    useEffect(() => {
        if (isMounted.current) return;
        if (shiftId) {
            loadDetails();
        }
        isMounted.current = true;
    }, [])

    const onChange = (val) => {
        setSelectedTab(val)
    }

   

    return (
        <div className="main-content">{console.log('sendData', sendData)}
            <div className='d-flex justify-content-between w-100 mb-3'>
                <div className='topNav'>
                    <button onClick={() => onChange('ACT')} className={selectedTab === 'ACT' ? 'nav_active' : ''}><Activity_icon />Activity</button>
                    {/* <button onClick={() => onChange('TSK')} className={selectedTab === 'TSK' ? 'nav_active' : ''}><Task_icon />Tasks</button> */}
                    <button onClick={() => onChange('ATT')} className={selectedTab === 'ATT' ? 'nav_active' : ''}><Attachment_icon />Attachments</button>

                </div>
                {/* {selectedTab === 'ACT' &&
                <div className='d-flex align-items-center gap-2' style={{ color: '#555', fontSize: '14px', fontWeight: 500 }}>
                    {details?.date && (
                        <span>
                            {details.date}
                        </span>
                    )}
                    {(details?.start_time || details?.end_time) && (
                        <>
                            {details?.date && <span style={{ color: '#ccc' }}>|</span>}
                            <FontAwesomeIcon icon={faClock} style={{ color: '#888' }} />
                            <span>
                                {details?.start_time?.slice(0, 5) ?? '--:--'}
                                {' - '}
                                {details?.end_time?.slice(0, 5) ?? '--:--'}
                            </span>
                        </>
                    )}
                </div>} */}
                <div className='mt-2'>
                    {selectedTab === 'ACT' &&
                        <>
                            <Button onClick={() => setShowModal(true)} className='me-2'><FontAwesomeIcon icon={faPlus} /> Add Activity</Button>
                            <Button variant='contained' onClick={() => setRemarks(!remarks)} className='outline_btn_blue'><Remarks_icon/> Remarks ({details?.comments?.length})</Button>
                        </>
                    }
                </div>
            </div>
            {selectedTab === 'ACT' &&
                <Activity
                    propData={details}
                    onReload={loadDetails}
                    openModal={showModal}
                    onclose={() => setShowModal(false)}
                    onComment={remarks}
                    closeRemarks={() => setRemarks(false)}
                />
            }
            {selectedTab === 'TSK' && <Tasks />}
            {selectedTab === 'ATT' && <div className='attachments_cmn'><Attachment propData={details} onReload={loadDetails} submitData={sendData} /></div>}

            
        </div>
    )
}

export default ShiftDetails